import React, { Component } from "react";
import { Table } from "semantic-ui-react";
import _ from "lodash";
import getDateRangeAddress from "./DateRangeAddress";
import getPersonMinDetail from "./PersonMinDetail";

class SubjectSharedAddressDetail extends Component {
  componentDidMount() {}

  render() {
    const sharedPersons = [];
    if (this.props.node !== undefined && this.props.node !== null) {
      const addresses = _.get(this.props.node, "addresses[0].address");
      if (addresses) {
        _.forEach(addresses, (address, addIndex) => {
          const subjectDateFrom = _.get(address, "dateFrom[0]._", "");
          const subjectDateTo = _.get(address, "dateTo[0]._", "");
          let subjectRowAdded = false;
          const persons = _.get(address, "sharedAddress[0].person");
          if (persons) {
            const conResRows = [];
            const nonConResRows = [];
            _.forEach(persons, (person, index) => {
              const newIndex = `${this.props.index}_${addIndex}_${index}`;
              const concurrentSharedAddressPerson = _.get(
                person,
                "concurrentSharedAddressPerson[0]._",
                ""
              );
              if (concurrentSharedAddressPerson.toLowerCase() === "yes") {
                conResRows.push(
                  getPersonMinDetail(
                    person,
                    newIndex,
                    this.props,
                    newIndex,
                    "yes"
                  )
                );
              } else if (concurrentSharedAddressPerson.toLowerCase() === "no") {
                nonConResRows.push(
                  getPersonMinDetail(person, index, this.props, newIndex, "no")
                );
              }
            });
            if (conResRows.length > 0) {
              if (!subjectRowAdded) {
                sharedPersons.push(
                  getDateRangeAddress(
                    "",
                    subjectDateFrom,
                    subjectDateTo,
                    address,
                    `sharedAdd_${this.props.index}_${addIndex}`,
                    this.props
                  )
                );
                subjectRowAdded = true;
              }
              sharedPersons.push(
                <Table.Row
                  key={`row_con_sharedAdd_${this.props.index}_${addIndex}`}
                >
                  <Table.Cell colSpan={100}>
                    <Table stackable key={`tbl_concsharedAdd_${addIndex}`}>
                      <Table.Body>
                        <Table.Row key={`row_con_header_${addIndex}`}>
                          <Table.Cell
                            colSpan={100}
                            className="report-sub-section-header"
                          >
                            Concurrent Residency
                          </Table.Cell>
                        </Table.Row>
                        {conResRows}
                      </Table.Body>
                    </Table>
                  </Table.Cell>
                </Table.Row>
              );
            }
            if (nonConResRows.length > 0) {
              if (!subjectRowAdded) {
                sharedPersons.push(
                  getDateRangeAddress(
                    "",
                    subjectDateFrom,
                    subjectDateTo,
                    address,
                    `sharedAdd_${this.props.index}_${addIndex}`,
                    this.props
                  )
                );
                subjectRowAdded = true;
              }
              sharedPersons.push(
                <Table.Row
                  key={`row_non_con_sharedAdd_${this.props.index}_${addIndex}`}
                >
                  <Table.Cell colSpan={100}>
                    <Table stackable key={`tbl_concsharedAdd_${addIndex}`}>
                      <Table.Body>
                        <Table.Row key={`row_non_con_header_${addIndex}`}>
                          <Table.Cell
                            colSpan={100}
                            className="report-sub-section-header"
                          >
                            Non-Concurrent Residency
                          </Table.Cell>
                        </Table.Row>
                        {nonConResRows}
                      </Table.Body>
                    </Table>
                  </Table.Cell>
                </Table.Row>
              );
            }
          }
        });
      }
    }
    return sharedPersons.length > 0 ? (
      <Table.Row key={`Subject_Shared_Address_Detail_Row_${this.props.index}`}>
        <Table.Cell colSpan={100}>
          <Table
            stackable
            key={`Subject_Shared_Address_Detail_Header_Name_${this.props.index}`}
          >
            <Table.Body>{sharedPersons}</Table.Body>
          </Table>
        </Table.Cell>
      </Table.Row>
    ) : null;
  }
}

export default SubjectSharedAddressDetail;



// WEBPACK FOOTER //
// ./src/components/reports/SubjectSharedAddressDetail.js